<div class="filter-client-purchase-order-type__wrapper">
  <div class="lum-label">{{ label }}</div>
  <input
    type="text"
    [value]="textValue"
    placeholder="Select Invoice Type"
    matInput
    class="lum-input"
    (input)="onSearchInputChange($event)"
    [matAutocomplete]="auto"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayFn"
    (optionSelected)="onSelectOption($event)"
  >
    <ng-container *ngIf="!(invoiceTypesLoading$ | async); else loader">
      <mat-option *ngFor="let type of invoiceTypes" [value]="type">
        {{ type.label }}
      </mat-option>
    </ng-container>
    <ng-template #loader>
      <mat-option>
        <div class="flex gap-4">
          <mat-progress-spinner
            class="progress-spinner mt-3"
            diameter="24"
            mode="indeterminate"
          ></mat-progress-spinner>
          <small>Loading...</small>
        </div>
      </mat-option>
    </ng-template>
  </mat-autocomplete>
</div>
